import { z } from 'zod';
import { enumToZodLiteralUnion } from '../../zodExtensions.js';
var TimelineEventTypeEnum;
(function (TimelineEventTypeEnum) {
    TimelineEventTypeEnum["email"] = "email";
    TimelineEventTypeEnum["shipment"] = "shipment";
    TimelineEventTypeEnum["processing"] = "processing";
    TimelineEventTypeEnum["simple"] = "simple";
    TimelineEventTypeEnum["money"] = "money";
    TimelineEventTypeEnum["comment"] = "comment";
    TimelineEventTypeEnum["shopify"] = "shopify";
})(TimelineEventTypeEnum || (TimelineEventTypeEnum = {}));
const timelineEvent = z.object({
    id: z.string().uuid(),
    datetime: z.string(),
    message: z.string(),
    type: enumToZodLiteralUnion(TimelineEventTypeEnum),
    subject: z.string().optional(),
});
export const claimTimelineEvent = timelineEvent;
export const claimTimeline = z.array(timelineEvent);
//# sourceMappingURL=claimTimeline.js.map